'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var core_Loading_DotsLoader = require('../Loading/DotsLoader.js');
var getReactNode = require('../../getReactNode-625f4d64.js');
var Button = require('../../Button-fac61fc0.js');
var react = require('@emotion/react');
var VisuallyHidden_style = require('../../VisuallyHidden.style-195957c9.js');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
require('../Loading/DotsLoader.style.js');
require('@babel/runtime/helpers/taggedTemplateLiteral');
require('styled-system');
require('@emotion/styled');
require('@babel/runtime/helpers/typeof');
require('@radix-ui/react-slot');
require('../../parseDataAttributes-81c8dbee.js');
require('@babel/runtime/helpers/slicedToArray');
require('lodash/fp/fromPairs');
require('lodash/fp/map');
require('lodash/fp/toPairs');
require('lodash/fp/flow');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);

var _excluded$2 = ["children", "loading", "prefixIcon", "disabled", "n-aria-loading-label", "aria-live", "aria-label"];
var withLoadingState = function withLoadingState(Button$1) {
  var LoadingButton = function LoadingButton(_ref) {
    var children = _ref.children,
      loading = _ref.loading,
      prefixIcon = _ref.prefixIcon,
      disabled = _ref.disabled,
      _ref$nAriaLoadingL = _ref['n-aria-loading-label'],
      ariaLoadingLabel = _ref$nAriaLoadingL === void 0 ? 'loading' : _ref$nAriaLoadingL,
      _ref$ariaLive = _ref['aria-live'],
      ariaLive = _ref$ariaLive === void 0 ? 'polite' : _ref$ariaLive,
      aLabel = _ref['aria-label'],
      restProps = _objectWithoutProperties__default["default"](_ref, _excluded$2);
    var hasAriaLabel = !!aLabel;
    var ariaLabel = hasAriaLabel ? "".concat(aLabel, " ").concat(loading ? ariaLoadingLabel : '') : undefined;
    var icon = loading ? react.jsx(React__default["default"].Fragment, null, react.jsx(Button.LoadingContainer, null, !!prefixIcon && getReactNode.getReactNode(prefixIcon)), react.jsx(Button.LoadingDots, null, react.jsx(core_Loading_DotsLoader["default"], {
      size: 7
    }))) : prefixIcon;
    return react.jsx(Button$1, _extends__default["default"]({}, restProps, {
      prefixIcon: icon,
      disabled: loading || disabled,
      "aria-label": ariaLabel,
      "aria-live": ariaLive
    }), loading ? react.jsx(Button.LoadingContainer, null, children) : children, loading && !hasAriaLabel && react.jsx(VisuallyHidden_style.VisuallyHidden, null, ariaLoadingLabel));
  };
  LoadingButton.displayName = 'WithLoadingState';
  return LoadingButton;
};

var _excluded$1 = ["children"];
var withFloatingPosition = function withFloatingPosition(Component) {
  var coordinates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var WrappedComponent = function WrappedComponent(_ref) {
    var children = _ref.children,
      restProps = _objectWithoutProperties__default["default"](_ref, _excluded$1);
    return react.jsx(Button.FloatingContainer, {
      style: _objectSpread__default["default"]({}, coordinates)
    }, react.jsx(Component, restProps, children));
  };
  WrappedComponent.displayName = 'WithFloating';
  return WrappedComponent;
};

var _excluded = ["children", "multiple", "accept", "onChange"];
var withUploadFile = function withUploadFile(Component) {
  var UploadButton = function UploadButton(_ref) {
    var children = _ref.children,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      accept = _ref.accept,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      restProps = _objectWithoutProperties__default["default"](_ref, _excluded);
    return react.jsx(Component, restProps, react.jsx(Button.UploadInput, {
      "aria-label": "upload",
      "aria-hidden": "true",
      onChange: onChange,
      type: "file",
      accept: accept,
      multiple: multiple
    }), children);
  };
  UploadButton.displayName = 'WithUploadFile';
  return UploadButton;
};

var ButtonLoading = withLoadingState(Button.Button);
var ButtonFloating = withFloatingPosition(Button.Button);
var ButtonUpload = withUploadFile(Button.Button);

exports.Button = Button.Button;
exports.ButtonFloating = ButtonFloating;
exports.ButtonLoading = ButtonLoading;
exports.ButtonUpload = ButtonUpload;
exports.withFloatingPosition = withFloatingPosition;
exports.withLoadingState = withLoadingState;
exports.withUploadFile = withUploadFile;
//# sourceMappingURL=index.js.map
